import { cancelJob } from "@/api/jobs";
import { useAccessToken } from "@/auth/useAccessToken";
import { useChatStore } from "@/runtime/chatStore";

export function AbortButton() {
  const ctrl = useChatStore((s) => s.abortController);
  const activeJobId = useChatStore((s) => s.activeJobId);
  const activeTenantId = useChatStore((s) => s.activeTenantId);
  const { acquireToken } = useAccessToken();

  async function onAbort() {
    if (activeJobId && activeTenantId) {
      try {
        const token = await acquireToken();
        await cancelJob(activeTenantId, activeJobId, token);
      } catch {
        /* best-effort; local abort still closes the SSE relay client-side */
      }
    }
    ctrl?.abort();
  }

  return (
    <button
      type="button"
      aria-label="Stop generating"
      title="Stop generating"
      onClick={onAbort}
      className="flex h-9 w-9 items-center justify-center rounded-[var(--radius-pill)] bg-[var(--surface-raised)] text-[var(--text-secondary)] shadow-[var(--elev-ring)] transition-all duration-[var(--dur-fast)] ease-[var(--ease-out)] hover:text-[var(--accent-primary)] hover:shadow-[var(--elev-ring-strong)] focus:outline-none focus-visible:shadow-[var(--elev-focus)]"
    >
      <svg width="10" height="10" viewBox="0 0 10 10" fill="currentColor" aria-hidden="true">
        <rect x="0.5" y="0.5" width="9" height="9" rx="1" />
      </svg>
    </button>
  );
}
